var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9966 27.717L17.278 15.3265C16.7231 15.1241 16.0983 15.2609 15.6802 15.6805C15.2622 16.0985 15.1238 16.7219 15.3262 17.2783L27.7168 50.9969C27.9325 51.5905 28.4919 51.9893 29.1241 51.9996C29.7485 52.0099 30.3256 51.6328 30.5627 51.0415L36.4139 36.4142L51.0412 30.563C51.6289 30.328 52.0097 29.7552 51.9994 29.1244C51.9889 28.4922 51.5903 27.9327 50.9966 27.717Z",
    fill: "url(#paint0_linear_31394_12017)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5013 16.7756C35.7308 7.36874 27.7283 0 18.2812 0C8.20033 0 0 8.20033 0 18.2812C0 27.7283 7.36874 35.7308 16.7756 36.5013C17.8558 36.5759 18.372 35.6863 18.4196 35.1073C18.4881 34.2682 17.8631 33.5333 17.0256 33.4633C9.1867 32.8222 3.04686 26.1527 3.04686 18.2812C3.04686 9.88148 9.88148 3.04686 18.2812 3.04686C26.1528 3.04686 32.8222 9.1867 33.4634 17.0256C33.5333 17.8631 34.2609 18.4865 35.1074 18.4196C35.945 18.3496 36.5698 17.6146 36.5013 16.7756ZM18.2812 6.09373C11.5611 6.09373 6.09373 11.5611 6.09373 18.2812C6.09373 23.2769 9.22986 27.8472 13.8953 29.6534C14.6804 29.9558 15.5632 29.5677 15.8665 28.7831C16.17 27.9976 15.7802 27.1154 14.9963 26.8119C11.4942 25.4564 9.14059 22.0287 9.14059 18.2812C9.14059 13.2408 13.2408 9.14059 18.2812 9.14059C22.0287 9.14059 25.4564 11.4942 26.8118 14.9963C27.1138 15.7817 27.9946 16.1701 28.783 15.8665C29.5671 15.5631 29.9569 14.6808 29.6533 13.8953C27.8472 9.22986 23.2769 6.09373 18.2812 6.09373Z",
    fill: "url(#paint1_linear_31394_12017)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31394_12017",
    x1: 15.2344,
    y1: 33.6171,
    x2: 51.9996,
    y2: 33.6171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31394_12017",
    x1: 0,
    y1: 18.2529,
    x2: 36.5064,
    y2: 18.2529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialBoost);
export default __webpack_public_path__ + "static/media/social-boost.01dc5f159db56a3b7e82648ed54a1db7.svg";
export { ForwardRef as ReactComponent };